/**
 * 動画ソース判定 + 埋め込み URL 生成（YouTube / Vimeo）。
 * Firebase Storage の動画は <video> タグで直接再生するため埋め込みURLは不要。
 */

export type VideoSource = 'firebase' | 'youtube' | 'vimeo';

const YOUTUBE_ID_RE = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/;
const VIMEO_ID_RE = /vimeo\.com\/(?:video\/|channels\/[\w-]+\/|groups\/[\w-]+\/videos\/)?(\d+)/;

export function extractYouTubeId(url: string): string | null {
  const m = url.match(YOUTUBE_ID_RE);
  return m ? m[1] : null;
}

export function youtubeEmbedUrl(id: string): string {
  return `https://www.youtube.com/embed/${id}`;
}

export function youtubeThumbnail(id: string): string {
  return `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
}

export function extractVimeoId(url: string): string | null {
  const m = url.match(VIMEO_ID_RE);
  return m ? m[1] : null;
}

export function vimeoEmbedUrl(id: string): string {
  return `https://player.vimeo.com/video/${id}`;
}

/**
 * URL からソース種別を推定（後方互換用）。
 * videoSource が未設定でも URL 文字列から自動判定できる。
 */
export function inferVideoSource(url: string | null | undefined): VideoSource {
  if (!url) return 'firebase';
  if (/youtube\.com|youtu\.be/.test(url)) return 'youtube';
  if (/vimeo\.com/.test(url)) return 'vimeo';
  return 'firebase';
}
